import script from "./ProductHistoryModalSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductHistoryModalSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./ProductHistoryModalSkeleton.vue?vue&type=style&index=0&id=ab731996&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab731996"]])

export default __exports__